import React from "react";
import { Modal, Button } from "@mantine/core";

interface TermsAndConditionsModalProps {
  opened: boolean;
  onClose: () => void;
}

function TermsAndConditionsModal(props: TermsAndConditionsModalProps) {
  return (
    <Modal size="auto" opened={props.opened} onClose={props.onClose}>
      <div className="terms-container">
        <h2>Terms of Use</h2>
        <h3>1. Acceptance of Terms</h3>
        <p>
          By accessing or using Soft Retired (“the Website”), you agree to be
          bound by these Terms of Use. If you do not agree to all the terms and
          conditions, you must not use the Website.
        </p>
        <h3>2. Use of the Website</h3>
        <p>
          The content provided on this Website is for general informational
          purposes only. We reserve the right to modify or discontinue the
          Website at any time, with or without notice.
        </p>
        <h3>3. No Warranties</h3>
        <p>
          The Website and its content are provided "as is" and "as available"
          without any warranties of any kind, either express or implied. We do
          not warrant that the Website will be error-free, secure, or
          uninterrupted.
        </p>
        <h3>4. Limitation of Liability</h3>
        <p>
          Under no circumstances shall SoftRetired Solutions Ltd., its
          affiliates, employees, or contractors be liable for any direct,
          indirect, incidental, special, or consequential damages that result
          from the use of, or the inability to use, the Website.
        </p>
        <h3>5. User Responsibilities</h3>
        <p>
          You are solely responsible for your use of the Website and for
          ensuring that such use complies with all applicable laws. You must not
          engage in any unlawful or prohibited activities while using the
          Website.
        </p>
        <h3>6. External Links</h3>
        <p>
          This Website may contain links to third-party websites. We are not
          responsible for the content, accuracy, or opinions expressed in such
          websites, and we assume no liability for any damages arising from your
          use of such links.
        </p>
        <h3>7. Indemnification</h3>
        <p>
          You agree to indemnify and hold harmless SoftRetired Solutions Ltd.
          from any claims, liabilities, damages, or expenses (including legal
          fees) arising from your use of the Website or your violation of these
          Terms of Use.
        </p>
        <h3>8. Changes to Terms</h3>
        <p>
          We reserve the right to modify these Terms of Use at any time. Your
          continued use of the Website following any changes constitutes
          acceptance of the new terms.
        </p>
        <h3>9. Governing Law</h3>
        <p>
          These Terms of Use are governed by and construed in accordance with
          the laws of the Province of Alberta and the laws of Canada, without
          regard to its conflict of law provisions.
        </p>
      </div>
      <div className="terms-close-button">
        <Button onClick={props.onClose}>Close</Button>
      </div>
    </Modal>
  );
}

export default TermsAndConditionsModal;
